import { Type } from "class-transformer";

import { ErrorResponseGeneric } from './errorResponseGeneric';

export class ErrorResponseProperty {
    propertyName: string;

    @Type(() => ErrorResponseGeneric)
    errors: ErrorResponseGeneric[];
}